export enum DrawerNav {
    DEFAULT_NAVIGATION = 'DEFAULT_NAVIGATION',
    MY_SETTINGS_CONTENT = 'MY_SETTINGS_CONTENT',
    MY_PROFILE_CONTENT = 'MY_PROFILE_CONTENT',
    MEETINGS_CONTENT = 'MEETINGS_CONTENT',
    TRANSIT_CONTENT = 'TRANSIT_CONTENT',
}

export const CSS_TRANSITION_DELAY = 300;
